import React, { Fragment } from "react";
import useForm from "react-hook-form";
import { connect } from "react-redux";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
// import options from '../../../data/typeaheadData';
import store from "store";
import MultiplePicture from "./multipalImage";
import Editor from "./editor1";
import PdfFile from "./pdfFile";

const ProductForm = (props) => {
  const { register, handleSubmit, errors } = useForm(); // initialise the hook
  var {
    info,
    onChangeUrl,
    searchProductUrl,
    searchUrlStatus,
    isEdit,
    isView,
    onChangeCategoryId,
    categoryList,
    onChangeBrandId,
    brandsList,
    pictursList,
    onProductImageChange,
    onChangeDescription,
    productDescription,
    selectedCategoryId,
    onChangeSubCategory,
    selectedBrandError,
    selectedCategoryError,
    selectedSubCategoryError,
    pdfFileUrl,
    onChangePdf,
    onChangePdfName,
  } = props;
  console.log({ props }, "pictursList--@");
  const onSubmit = (data) => {
    if (data !== "") {
      // onSubmitForm()/
      props.onClickConfirm(data);
    } else {
      errors.showMessages();
    }
  };
  const multiplePictureProps = {
    pictursList: pictursList,
    onProductImageChange: onProductImageChange,
  };
  const editorProps = {
    productDescription: productDescription,
    onChangeDescription: onChangeDescription,
  };
  console.log({ categoryList, selectedCategoryId });
  var subCategoryList = (
    categoryList.filter((item) => {
      return selectedCategoryId === item._id;
    }) || []
  ).pop();
  subCategoryList =
    subCategoryList && subCategoryList.subCategory
      ? subCategoryList.subCategory
      : [];
  console.log({ categoryList, selectedCategoryId, subCategoryList });
  const pdfProps = {
    pdfFileUrl: pdfFileUrl,
    onChangePdf: onChangePdf,
    onChangePdfName: onChangePdfName,
  };
  return (
    // <Fragment>
    //   <div className="container-fluid">
    //     <div className="card-body">
    //       <form
    //         id="product-form"
    //         className="needs-validation"
    //         onSubmit={handleSubmit(onSubmit)}
    //       >
    //         <div className="form-row">
    //           {/* Start Product Name tag */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //               Product Name
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <input
    //                 className="form-control"
    //                 name="name"
    //                 type="text"
    //                 defaultValue={info.name}
    //                 placeholder="Product name..."
    //                 onChange={(e) => onChangeUrl(e.target.value)}
    //                 ref={register({ required: true })}
    //                 disabled={isView}
    //               />
    //               <span>{errors.name && "Name is required"}</span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start Product Model */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //               Product Model
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <input
    //                 className="form-control"
    //                 name="model"
    //                 type="text"
    //                 defaultValue={info.model}
    //                 placeholder="Product model..."
    //                 ref={register({ required: true })}
    //                 disabled={isView}
    //               />
    //               <span>{errors.model && "Product model is required"}</span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start Select Brand */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //               Select Brand
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <Typeahead
    //                 id="basic-typeahead"
    //                 labelKey={(option) => `${option.name}`}
    //                 selected={
    //                   info.brandId &&
    //                   (brandsList || []).length > 0 &&
    //                   brandsList.filter(
    //                     (item) =>
    //                       info.brandId &&
    //                       (item._id === info.brandId._id ||
    //                         item._id === info.brandId)
    //                   )
    //                 }
    //                 multiple={false}
    //                 options={brandsList}
    //                 onInputChange={(input) => console.log({ input })}
    //                 // onChange={value => console.log({ value })}
    //                 onChange={(value) => {
    //                   value.length > 0 &&
    //                     onChangeBrandId(value[0]["_id"], value[0]["sUrl"]);
    //                 }}
    //                 name="brand"
    //                 ref={register({
    //                   required: true,
    //                 })}
    //                 placeholder="Choose a brand..."
    //                 disabled={isView}
    //               />
    //               <span style={{ color: "#ff5370" }}>
    //                 {selectedBrandError && "Brand is required"}
    //               </span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start Select Category */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //               Select Category
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <Typeahead
    //                 id="basic-typeahead"
    //                 labelKey={(option) => `${option.name}`}
    //                 selected={
    //                   info.categoryId &&
    //                   (categoryList || []).length > 0 &&
    //                   categoryList.filter(
    //                     (item) =>
    //                       info.categoryId &&
    //                       (item._id === info.categoryId._id ||
    //                         item._id === info.categoryId)
    //                   )
    //                 }
    //                 multiple={false}
    //                 options={categoryList}
    //                 onInputChange={(input) => console.log({ input })}
    //                 onChange={(value) => {
    //                   value.length > 0 &&
    //                     onChangeCategoryId(value[0]["_id"], value[0]["sUrl"]);
    //                 }}
    //                 name="category"
    //                 ref={register({
    //                   required: true,
    //                 })}
    //                 placeholder="Choose a category..."
    //                 disabled={isView}
    //               />
    //               <span style={{ color: "#ff5370" }}>
    //                 {selectedCategoryError && "Category is required"}
    //               </span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start Select Sub-Category */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //               Select Sub-Category
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <Typeahead
    //                 id="basic-typeahead"
    //                 selected={info.subCategory}
    //                 multiple
    //                 options={
    //                   subCategoryList && subCategoryList.length > 0
    //                     ? subCategoryList
    //                     : [] || []
    //                 }
    //                 onChange={(value) => onChangeSubCategory(value)}
    //                 name="subCategory"
    //                 ref={register({
    //                   required: true,
    //                 })}
    //                 placeholder="Choose a sub-category..."
    //                 disabled={isView}
    //               />
    //               <span style={{ color: "#ff5370" }}>
    //                 {selectedSubCategoryError && "Sub-Category is required"}
    //               </span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start Page Url */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //               Page Url
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <input
    //                 className="form-control"
    //                 name="sUrl"
    //                 type="text"
    //                 value={info.sUrl || ""}
    //                 placeholder="Page url..."
    //                 onChange={(e) => onChangeUrl(null, e.target.value)}
    //                 ref={register({ required: true })}
    //                 disabled={isView}
    //               />
    //               <span>{errors.sUrl && "Page url is required"}</span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start Page Title */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //               Page Title
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <input
    //                 className="form-control"
    //                 name="sTitle"
    //                 type="text"
    //                 defaultValue={info.sTitle}
    //                 placeholder="Page title..."
    //                 ref={register({ required: true })}
    //                 disabled={isView}
    //               />
    //               <span>{errors.sTitle && "Product title is required"}</span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start Page Keyword */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //               Page Keyword
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <input
    //                 className="form-control"
    //                 name="sKeyword"
    //                 type="text"
    //                 defaultValue={info.sKeyword || ""}
    //                 placeholder="Page keyword..."
    //                 ref={register({ required: true })}
    //                 disabled={isView}
    //               />
    //               <span>{errors.sKeyword && "Page keyword is required"}</span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start  Page Description */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
    //               Page Description
    //               {!isView && <span>*</span>}
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <textarea
    //                 className="form-control"
    //                 name="shortDescription"
    //                 type="text"
    //                 row="6"
    //                 defaultValue={info.shortDescription}
    //                 placeholder="Page description..."
    //                 ref={register({
    //                   required: true,
    //                 })}
    //                 style={{ height: "104px" }}
    //                 disabled={isView}
    //               />
    //               <span style={{ color: "#ff5370" }}>
    //                 {errors.shortDescription && "Page description is required"}
    //               </span>
    //               <div className="valid-feedback">Looks good!</div>
    //             </div>
    //           </div>
    //           {/* Start Picture's */}
    //           <div className="col-md-6 mb-12 p-t-5  p-b-5">
    //             <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
    //               Picture's
    //               {!isView && <span>*</span>}{" "}
    //               {
    //                 <i
    //                   style={{ fontSize: "12px" }}
    //                 >{`Image Size 255x291 pixels`}</i>
    //               }
    //             </label>
    //             <div className=" p-l-15 p-r-15">
    //               <MultiplePicture {...multiplePictureProps} isView={isView} />
    //             </div>
    //           </div>
    //           {/* Start Description */}
    //           {!isView && (
    //             <div className="col-md-12 mb-12 p-t-5  p-b-5">
    //               <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
    //                 Description
    //                 {!isView && <span>*</span>}
    //               </label>
    //               <div className=" p-l-15 p-r-15">
    //                 <Editor {...editorProps} />
    //                 <span style={{ color: "#ff5370" }}>
    //                   {errors.description && "Description is required"}
    //                 </span>
    //                 <div className="valid-feedback">Looks good!</div>
    //               </div>
    //             </div>
    //           )}
    //           {/* Start Upload Pdf*/}
    //           {!isView && (
    //             <div className="col-md-4 mb-12 p-t-5  p-b-5">
    //               <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
    //                 Pdf File
    //               </label>
    //               <div className=" p-l-15 p-r-15">
    //                 <PdfFile {...pdfProps} />
    //               </div>
    //             </div>
    //           )}
    //           {/* Start   Pdf Name*/}
    //           {!isView && (
    //             <div className="col-md-8 mb-12 p-t-5  p-b-5">
    //               <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
    //                 Pdf File Name
    //               </label>
    //               <div className=" p-l-15 p-r-15">
    //                 <input
    //                   className="form-control"
    //                   name="pdfFileName"
    //                   type="text"
    //                   value={info.pdfFileName || ""}
    //                   placeholder="Pdf name..."
    //                   onChange={(e) => onChangePdfName(e.target.value)}
    //                   // ref={register({ required: true })}
    //                 />
    //                 <span>
    //                   {errors.pdfFileName && "Pdf Name is required"}
    //                   {info.pdfFileName}
    //                 </span>
    //                 <div className="valid-feedback">Looks good!</div>
    //               </div>
    //             </div>
    //           )}
    //         </div>
    //         {!isView && (
    //           <div className="p-15">
    //             <button className="btn btn-primary float-right " type="submit">
    //               {isEdit ? "Update" : "Submit"}
    //             </button>
    //           </div>
    //         )}
    //       </form>
    //     </div>
    //   </div>
    // </Fragment>

    <Fragment>
      <div className="container-fluid">
        <div style={{padding:"30px"}}>
          <form
            id="product-form"
            className="needs-validation"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">

              {/* Product Name */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Product Name {!isView && <span>*</span>}
                </label>
                <input
                  className="form-control"
                  name="name"
                  type="text"
                  defaultValue={info?.name}
                  placeholder="Product name..."
                  onChange={(e) => onChangeUrl(e.target.value)}
                  ref={register({ required: true })}
                  disabled={isView}
                />
                {errors.name && <small className="text-danger">Name is required</small>}
              </div>

              {/* Product Model */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Product Model {!isView && <span>*</span>}
                </label>
                <input
                  className="form-control"
                  name="model"
                  type="text"
                  defaultValue={info?.model}
                  placeholder="Product model..."
                  ref={register({ required: true })}
                  disabled={isView}
                />
                {errors.model && <small className="text-danger">Model is required</small>}
              </div>

              {/* Brand */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Select Brand {!isView && <span>*</span>}
                </label>
                <Typeahead
                  labelKey="name"
                  selected={
                    info?.brandId &&
                    brandsList?.filter(
                      item => item._id === info.brandId?._id || item._id === info.brandId
                    )
                  }
                  options={brandsList}
                  onChange={(value) =>
                    value.length && onChangeBrandId(value[0]._id, value[0].sUrl)
                  }
                  placeholder="Choose a brand..."
                  disabled={isView}
                />
                {selectedBrandError && (
                  <small className="text-danger">Brand is required</small>
                )}
              </div>

              {/* Category */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Select Category {!isView && <span>*</span>}
                </label>
                <Typeahead
                  labelKey="name"
                  selected={
                    info?.categoryId &&
                    categoryList?.filter(
                      item =>
                        item._id === info.categoryId?._id ||
                        item._id === info.categoryId
                    )
                  }
                  options={categoryList}
                  onChange={(value) =>
                    value.length && onChangeCategoryId(value[0]._id, value[0].sUrl)
                  }
                  placeholder="Choose a category..."
                  disabled={isView}
                />
                {selectedCategoryError && (
                  <small className="text-danger">Category is required</small>
                )}
              </div>

              {/* Sub Category */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Select Sub-Category {!isView && <span>*</span>}
                </label>
                <Typeahead
                  multiple
                  selected={info?.subCategory}
                  options={subCategoryList || []}
                  onChange={onChangeSubCategory}
                  placeholder="Choose sub-category..."
                  disabled={isView}
                />
                {selectedSubCategoryError && (
                  <small className="text-danger">Sub-Category is required</small>
                )}
              </div>

              {/* Page URL */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Page URL {!isView && <span>*</span>}
                </label>
                <input
                  className="form-control"
                  name="sUrl"
                  value={info?.sUrl || ""}
                  placeholder="Page url..."
                  onChange={(e) => onChangeUrl(null, e.target.value)}
                  ref={register({ required: true })}
                  disabled={isView}
                />
                {errors.sUrl && <small className="text-danger">URL required</small>}
              </div>

              {/* Page Title */}
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Page Title
                  {!isView && <span>*</span>}
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="sTitle"
                    type="text"
                    defaultValue={info?.sTitle}
                    placeholder="Page title..."
                    ref={register({ required: true })}
                    disabled={isView}
                  />
                  <span>{errors.sUrl && "Page url is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>

              {/* Page Keyword */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Page Keyword {!isView && <span>*</span>}
                </label>
                <input
                  className="form-control"
                  name="sKeyword"
                  type="text"
                  defaultValue={info?.sKeyword || ""}
                  placeholder="Page keyword..."
                  ref={register({ required: true })}
                  disabled={isView}
                />
                {errors.sUrl && <small className="text-danger">URL required</small>}
              </div>

              {/* Page Description (Full Width) */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Page Description {!isView && <span>*</span>}
                </label>
                <textarea
                  className="form-control"
                  name="shortDescription"
                  rows="4"
                  defaultValue={info?.shortDescription}
                  ref={register({ required: true })}
                  disabled={isView}
                />
                {errors.shortDescription && (
                  <small className="text-danger">Description required</small>
                )}
              </div>

              {/* Images */}
              <div className="col-12 col-md-6 mb-3">
                <label>
                  Pictures {!isView && <span>*</span>}
                  <small className="text-muted ms-2">
                    Image Size 255×291
                  </small>
                </label>
                <MultiplePicture {...multiplePictureProps} isView={isView} />
              </div>

              {/* Editor (Full Width) */}
              {!isView && (
                <div className="col-12 mb-3">
                  <label>
                    Description <span>*</span>
                  </label>
                  <Editor {...editorProps} />
                </div>
              )}

              {/* Start Upload Pdf*/}
              {!isView && (
                <div className="col-12 col-md-4 mb-3">
                  <label>
                    Pdf File
                  </label>
                  <div>
                    <PdfFile {...pdfProps} />
                  </div>
                </div>
              )}

              {/* Start Pdf Name*/}
              {!isView && (
                <div className="col-12 col-md-8 mb-3">
                  <label>
                    Pdf File Name
                  </label>
                  <input
                    className="form-control"
                    name="pdfFileName"
                    type="text"
                    value={info?.pdfFileName || ""}
                    placeholder="Pdf name..."
                    onChange={(e) => onChangePdfName(e.target.value)}
                  // ref={register({ required: true })}
                  />
                  <span>
                    {errors.pdfFileName && "Pdf Name is required"}
                    {info.pdfFileName}
                  </span>
                </div>
              )}

            </div>

            {!isView && (
              <div className="text-end mt-3">
                <button className="btn btn-primary" type="submit">
                  {isEdit ? "Update" : "Submit"}
                </button>
              </div>
            )}
          </form>
        </div>
      </div >
    </Fragment >


  );
};
export default connect()(ProductForm);
